import { canUseCalendarBoard } from 'owa-calendar-board-launch';
import { updateSelectedDate } from 'owa-calendar-surface';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { processDateRangeTypeOrDayRangeChange } from 'owa-calendar-surface-view-store';
import { CalendarViewTypeEnum, CalendarViewTypeEnumToDateRangeType } from 'owa-calendar-view-type';
import { lazyOpenBoardProject } from 'owa-calendar-board';
import { isOutlookSpaceId, ProjectId } from 'owa-timestream-types';
import { getDate, getMonth, getYear, userDate } from 'owa-datetime';
import {
    getSelectedViewType,
    processCalendarViewType,
    updateSelectedViewType,
    SelectedViewTypeSource,
} from 'owa-calendar-module-store';
import {
    CalendarViewRouteParameters,
    USER_CALENDAR_VIEW_TYPE_ROUTE,
    CalendarViewRouteTypeExtended,
} from './calendarRoutes';

// TODO: VSO #93977 Rationalize module routing when canvas view type is explicitly specified for surface-only routes

/**
 * The route handler for displaying different calendar views
 */
export default function viewRouteHandler(parameters: CalendarViewRouteParameters): Promise<void> {
    const { view, y, m, d, forceSurfaceViewType, projectId } = parameters;

    const calendarViewType = getCalendarViewFromRoute(view, forceSurfaceViewType);
    const selectedDate = surfaceStore.selectedDate;
    const date: number = d ? d : getDate(selectedDate);
    const month: number = m ? m - 1 : getMonth(selectedDate);
    const year: number = y ? y : getYear(selectedDate);

    updateSelectedViewType(calendarViewType, SelectedViewTypeSource.ViewRouteHandler);
    updateSelectedDate(userDate(year, month, date), surfaceStore);

    if (
        canUseCalendarBoard() &&
        calendarViewType === CalendarViewTypeEnum.Board &&
        projectId &&
        isOutlookSpaceId(projectId)
    ) {
        lazyOpenBoardProject.importAndExecute((projectId as unknown) as ProjectId);
    }

    return processDateRangeTypeOrDayRangeChange(
        CalendarViewTypeEnumToDateRangeType(calendarViewType),
        getNumDaysInDayRange(),
        true,
        false // source not a user change
    );
}

function getCalendarViewFromRoute(
    view: CalendarViewRouteTypeExtended | undefined,
    forceSurfaceViewType?: boolean
): CalendarViewTypeEnum {
    switch (view) {
        case 'day':
            return CalendarViewTypeEnum.Daily;
        case 'week':
            return CalendarViewTypeEnum.Weekly;
        case 'workweek':
            return CalendarViewTypeEnum.WorkWeek;
        case 'month':
            return CalendarViewTypeEnum.Monthly;
        case 'board':
            return processCalendarViewType(CalendarViewTypeEnum.Board, forceSurfaceViewType);
        case USER_CALENDAR_VIEW_TYPE_ROUTE:
        default:
            return getSelectedViewType(forceSurfaceViewType);
    }
}
